<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; padding: 20px;">

  <!-- Search -->
  <div style="position: relative; margin-bottom: 16px;">
    <mat-icon style="position: absolute; left: 14px; top: 50%; transform: translateY(-50%); font-size: 18px; width: 18px; height: 18px; color: #9ca3af;">search</mat-icon>
    <input #searchInput type="text" (keyup)="buscar($event)" [(ngModel)]="searchTxt" placeholder="Buscar cuenta..."
      style="width: 100%; padding: 12px 16px 12px 42px; border: 2px solid #e5e7eb; border-radius: 12px; font-size: 0.9rem; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
      (focus)="searchInput.style.borderColor='#34d399'"
      (blur)="searchInput.style.borderColor='#e5e7eb'">
  </div>

  <!-- Add account button -->
  <button type="button" (click)="openCreateDialog()"
    style="width: 100%; padding: 12px; border: 2px dashed #1C593D; background: white; color: #1C593D; border-radius: 12px; font-size: 0.85rem; font-weight: 600; cursor: pointer; margin-bottom: 20px; transition: all 0.2s;"
    onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle; margin-right: 4px; color: #1C593D;">add</mat-icon>
    Agregar cuenta de retiro
  </button>

  <!-- Account list -->
  <div *ngIf="accountsListFiltered && accountsListFiltered.length > 0" style="margin-bottom: 16px;">
    <h3 style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; margin: 0 0 12px;">Tus cuentas</h3>
    <div style="display: flex; flex-direction: column; gap: 10px; max-height: 300px; overflow-y: auto;">
      <label *ngFor="let account of accountsListFiltered"
        (click)="elegir(account)"
        style="display: flex; align-items: center; gap: 12px; padding: 14px; border: 2px solid; border-radius: 12px; cursor: pointer; transition: all 0.2s;"
        [style.borderColor]="accountSelected === account ? '#1C593D' : '#e5e7eb'"
        [style.background]="accountSelected === account ? '#f0fdf4' : 'white'">

        <!-- Bank icon -->
        <div style="width: 42px; height: 42px; border-radius: 50%; background: linear-gradient(135deg, #1C593D, #34d399); display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: white;">account_balance</mat-icon>
        </div>

        <!-- Info -->
        <div style="flex: 1; min-width: 0;">
          <span style="display: block; font-size: 0.85rem; font-weight: 600; color: #1e5a3f;">{{ account.alias }}</span>
          <span style="display: flex; flex-wrap: wrap; align-items: center; gap: 4px; font-size: 0.75rem; color: #6b7280;">
            <span>{{ account.banco }}</span>
            <span>·</span>
            <span>{{ account.tipoCuenta }}</span>
            <span>·</span>
            <span style="font-family: monospace;">{{ account.numeroCuenta }}</span>
          </span>
        </div>

        <!-- Radio indicator -->
        <div style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid; flex-shrink: 0; display: flex; align-items: center; justify-content: center;"
          [style.borderColor]="accountSelected === account ? '#1C593D' : '#d1d5db'"
          [style.background]="accountSelected === account ? '#1C593D' : 'white'">
          <div *ngIf="accountSelected === account"
            style="width: 8px; height: 8px; background: white; border-radius: 50%;"></div>
        </div>
      </label>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!accountsListFiltered || accountsListFiltered.length === 0"
    style="text-align: center; padding: 30px 16px; border: 2px dashed #e5e7eb; border-radius: 12px; margin-bottom: 16px;">
    <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #d1d5db; margin-bottom: 8px;">account_balance</mat-icon>
    <p style="font-size: 0.9rem; font-weight: 600; color: #1e5a3f; margin: 0 0 4px;">No tienes cuentas registradas</p>
    <p style="font-size: 0.78rem; color: #6b7280; margin: 0;">Agrega una para continuar</p>
  </div>

  <!-- Continue button -->
  <button type="button" (click)="emitChangeStep()" [disabled]="accountSelected == undefined"
    [style.opacity]="accountSelected == undefined ? '0.5' : '1'"
    [style.cursor]="accountSelected == undefined ? 'not-allowed' : 'pointer'"
    style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.95rem; cursor: pointer; transition: background 0.2s ease;"
    onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_forward</mat-icon>
    Continuar
  </button>
</div>
